import { Spin } from 'antd'
import { SelectProps } from 'antd/lib'
import { useMemo } from 'react'

import { useIdentityRolesServiceGetRolesListEndpoint } from 'src/api/queries'
import { Select } from 'src/components'
import { useDefaultSortingItem } from 'src/hooks'
import { useLocales } from 'src/locales'

type Props = {
  hasDefault?: boolean
  legalEntityId?: string
} & SelectProps

export const RoleSelect = ({
  hasDefault = true,
  legalEntityId,
  ...props
}: Props) => {
  const { t } = useLocales()

  const { defaultSortingOption } = useDefaultSortingItem()
  const { data, isLoading } = useIdentityRolesServiceGetRolesListEndpoint({
    legalEntityId
  })

  const options = useMemo(() => {
    const roleOptions = data?.data?.map((item) => ({
      value: item.id,
      label: item.name
    }))

    if (hasDefault) return [defaultSortingOption, ...(roleOptions || [])]

    return roleOptions
  }, [data])

  return (
    <Spin spinning={isLoading}>
      <Select
        placeholder={t('common.role')}
        options={options}
        {...props}
        value={isLoading ? undefined : props.value}
      />
    </Spin>
  )
}
